<template>
	<div>
		<div class="panel m-5">
			<PanelHeader :panel-header="panelHeader" />
			<div class="container pt-3 pb-3">
				<div class="columns">
					<InputWithValidation class="column" message="Bitte geben Sie einen Bezeichner ein!"
						:name="anwesenheitsgrundName" :set-name="(val) => (anwesenheitsgrundName = val)"
						label="Bezeichner" />
					<ColorPicker class="column" :colors="anwesenheitsgrundColor" :set-colors="setColors" />
					<InputComponent class="column" :name="anwesenheitsgrundHint" :key="isMounted ? 'hinte' : 'hint'"
						:set-name="(val) => (anwesenheitsgrundHint = val)" label="Kürzel" />
				</div>
			</div>
		</div>

		<div class="m-5 buttons" style="display: flex; justify-content: center">
			<SaveButton :is-loading="isLoading"
				:disabled="$v.anwesenheitsgrundName.$invalid || $v.anwesenheitsgrundColor.$invalid"
				:save-function="saveData" />
			<CancelButton text="Abbrechen" back-route="/anwesenheit" :is-loading="false" />
		</div>
	</div>
</template>

<script>

import Parse from "parse/dist/parse.min.js";
import { minLength, required } from "vuelidate/lib/validators";
import PanelHeader from "@/components/helperComponents/PanelHeader";
import InputWithValidation from "@/components/helperComponents/InputWithValidation";
import InputComponent from "@/components/helperComponents/InputComponent";
import CancelButton from "@/components/helperComponents/CancelButton";
import SaveButton from "@/components/helperComponents/SaveButton";
import ColorPicker from "@/components/helperComponents/ColorPicker";
import {positiveFeedBack, negativeFeedBack} from "@/lib/Toast";

export default {
	name: "NewAnwesenheit",
	components: {
		PanelHeader,
		InputWithValidation,
		InputComponent,
		ColorPicker,
		SaveButton,
		CancelButton,
	},
	data() {
		return {
			isLoading: false,
			isMounted: false,
			anwesenheitsgrund: undefined,
			anwesenheitsgrundName: "",
			anwesenheitsgrundColor: {
				"hex": "#000000",
				"source": "hex"
			},
			anwesenheitsgrundHint: "",
			panelHeader: "Neuen Anwesenheitsgrund anlegen"
		};
	},
	watch: {},
	mounted() {
		this.scrollToElement()
		if (this.$route.params.data) {
			this.anwesenheitsgrund = this.$route.params.data
			this.anwesenheitsgrundName = this.anwesenheitsgrund.attributes.name
			this.anwesenheitsgrundColor.hex = this.anwesenheitsgrund.attributes.color
			this.anwesenheitsgrundHint = this.anwesenheitsgrund.attributes.hint
			this.panelHeader = "Anwesenheitsgrund bearbeiten"
			this.isMounted = true
		}
	},
	validations: {
		anwesenheitsgrundName: {
			required,
			minLength: minLength(1),
		},
		anwesenheitsgrundColor: {
			required,
		},
	},
	methods: {
		setColors(colors) {
			this.anwesenheitsgrundColor = colors
		},
		async saveData() {
			this.isLoading = true;
			const Anwesenheitsgrund = Parse.Object.extend("Presence")
			const anwesenheitsgrund = this.anwesenheitsgrund ? this.anwesenheitsgrund : new Anwesenheitsgrund()
			anwesenheitsgrund.set("name", this.anwesenheitsgrundName)
			anwesenheitsgrund.set("color", this.anwesenheitsgrundColor.hex)
			anwesenheitsgrund.set("hint", this.anwesenheitsgrundHint)
			anwesenheitsgrund.set("deleted", false)
			await anwesenheitsgrund.save().catch((e) => {
				negativeFeedBack("Anwesenheitsgrund nicht gespeichert!")
			});
			this.isLoading = false;
			await this.$router.push({ path: "/anwesenheit" })
			await positiveFeedBack("Anwesenheitsgrund gespeichert!")
		},
		scrollToElement() {
			const el = this.$parent.$parent.$refs.scrollToMe;
			if (el) {
				el.scrollIntoView({ behavior: 'smooth' });
			}
		},
	}
};


</script>

<style lang="scss" scoped>
.image_column {
	max-width: 200px;
}

.anwesenheitstage {
	flex-direction: column;
}
</style>
